<template>
    <div class="company-emr mb-3 mt-page">

        <data-form
            :title="$i18n.gt('HEADING_EDIT_COMPANY_EMR')"
            :save-button-label="$i18n.gt('LABEL_SAVE')"
            :field-model="companyFields"
            :field-groups="fieldGroups"
            :load-model-instance="loadModelInstance"
            :on-submit-handler="onSubmit"
            :submit-success-message="$i18n.gt('LABEL_COMPANY_UPDATED')"
            :submit-error-message="$i18n.gt('LABEL_ERROR_UPDATING_COMPANY')"
            :submit-success-route="successRoute"
            :cancel-route="successRoute">
            <template v-slot:preview="slotProps" v-if="hasEmr">
                <b-row class="mx-5 mt-4" v-if="emrScope">
                    <b-col>
                        EMR scope from last save:<br/><em>{{ emrScope }}</em>
                    </b-col>
                </b-row>
                <b-row class="mx-5 mt-4">
                    <b-col>
                        <b-btn size="sm" @click="emrCapabilities()">
                            {{ $i18n.gt('HEADING_LABEL_EMR_CAPABILITIES') }}
                        </b-btn>
                    </b-col>
                </b-row>
            </template>
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import * as _ from 'lodash'
import CompanyFields from '../models/Company'

/**
 * Page for admin to edit a Company
 */
export default Vue.extend({
    name: 'CompanyEmr',
    props: {
        companyId: Number,
    },
    data() {
        return {
            companyFields: CompanyFields,
            fieldGroups: [
                ['emr_info'],
            ],
            hasEmr: false,
            emrScope: null
        }
    },
    computed: {
        successRoute() {
            if (this.$user.roleIsAdmin()) {
                return `/company/id/${this.companyId}`
            } else {
                return '/' // company admin dashboard
            }
        },
    },
    methods: {
        loadModelInstance() {
            return this.$api.getItem(this, 'company', this.companyId, ['hasEMR'])
                .then((company) => {
                    console.log('CompanyEmr:loadModelInstance  company=', company)
                    this.hasEmr = company.has_emr
                    this.emrScope = company.emr_scope
                    return company
                })
        },
        onSubmit(modelInstance) {
            // check for DELETE characters
            if (modelInstance.emr_info === 'XXX') {
                modelInstance.emr_info = ''
            }
            return this.$api.updateItem(this, 'company', modelInstance)
        },
        async emrCapabilities() {
            let response = await this.$api.emrCapabilities(this, {
                company: this.companyId
            })
            //console.log('CompanyEmr:emrCapabilities  response=', response)
            if (response) {
                this.$toasted.info(
                    'Capability statement received',
                    {duration: 5000}
                )
            } else {
                this.$toasted.error(
                    'Unable to retrieve capabilities statement',
                    {duration: 5000}
                )
            }
        },
    }
})

</script>
